"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MouseTransformHandler = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _useEventCallback = _interopRequireDefault(require("use-event-callback"));

var _useToolMode3 = _interopRequireDefault(require("../../hooks/use-tool-mode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Container = (0, _styles.styled)("div")({});

var MouseTransformHandler = function MouseTransformHandler(_ref) {
  var children = _ref.children,
      matrix = _ref.matrix,
      onChangeMatrix = _ref.onChangeMatrix,
      onDragDuration = _ref.onDragDuration,
      onDragDurationStart = _ref.onDragDurationStart,
      onDragDurationEnd = _ref.onDragDurationEnd,
      onCreateTimestamp = _ref.onCreateTimestamp;
  var mousePosition = (0, _react.useRef)({
    x: 0,
    y: 0
  });

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      dragStartTime = _useState2[0],
      setDragStartTime = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      primaryDrag = _useState4[0],
      setPrimaryDrag = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      shiftKeyDown = _useState6[0],
      setShiftKeyDown = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      middleMouseDown = _useState8[0],
      setMiddleMouseDown = _useState8[1];

  var _useToolMode = (0, _useToolMode3.default)(),
      _useToolMode2 = _slicedToArray(_useToolMode, 1),
      toolMode = _useToolMode2[0];

  var containerRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var onKeyDown = function onKeyDown(e) {
      if (e.key === "Shift") {
        setShiftKeyDown(true);
      }
    };

    var onKeyUp = function onKeyUp(e) {
      if (e.key === "Shift") {
        setShiftKeyDown(false);
      }
    };

    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("keyup", onKeyUp);
    return function () {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("keyup", onKeyUp);
    };
  }, []);
  var projectMouse = (0, _useEventCallback.default)(function (e) {
    var clientX = e.clientX,
        clientY = e.clientY;
    var rect = containerRef.current.getBoundingClientRect();
    var xRelToElm = clientX - rect.x;
    var yRelToElm = clientY - rect.y;
    return matrix.inverse().applyToPoint(xRelToElm, yRelToElm);
  });
  var onWheel = (0, _useEventCallback.default)(function (e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    var deltaY = e.deltaY;
    var scroll = -Math.sign(deltaY) / 10;
    var _mousePosition$curren = mousePosition.current,
        px = _mousePosition$curren.px,
        py = _mousePosition$curren.py;
    onChangeMatrix(matrix.translate(px, py).scale(1 + (shiftKeyDown ? 0 : scroll), 1 + (shiftKeyDown ? scroll : 0)).translate(-px, -py));
  });
  var onMouseMove = (0, _useEventCallback.default)(function (e) {
    var clientX = e.clientX,
        clientY = e.clientY;
    var projectedMouse = projectMouse(e);

    if (middleMouseDown) {
      var delta = {
        x: clientX - mousePosition.current.x,
        y: clientY - mousePosition.current.y
      };
      var scaleFac = {
        x: matrix.get("a"),
        y: matrix.get("d")
      };
      onChangeMatrix(matrix.translate(delta.x / scaleFac.x, delta.y / scaleFac.y));
    }

    if (primaryDrag) {
      onDragDuration(dragStartTime, projectedMouse.x);
    }

    mousePosition.current = {
      x: clientX,
      y: clientY,
      px: projectedMouse.x,
      py: projectedMouse.y
    };
  });
  var onMouseDown = (0, _useEventCallback.default)(function (e) {
    if (toolMode === "zoom" && e.button !== 1) return;
    var clientX = e.clientX,
        clientY = e.clientY,
        button = e.button;
    var projectedMouse = projectMouse(e);
    mousePosition.current = {
      x: clientX,
      y: clientY,
      px: projectedMouse.x,
      py: projectedMouse.y
    };
    setDragStartTime(projectedMouse.x);

    if (toolMode === "pan" || button === 1 || e.button === 2) {
      setMiddleMouseDown(true);
      e.preventDefault();
    } else if (button === 0) {
      onDragDurationStart(projectMouse.x);
      setPrimaryDrag(true);
    }
  });
  var onMouseUp = (0, _useEventCallback.default)(function (e) {
    if (toolMode === "zoom" && e.button !== 1) {
      if (e.button === 2) {
        onWheel(_objectSpread(_objectSpread({}, e), {}, {
          deltaY: 100
        }));
      } else if (e.button === 0) {
        onWheel(_objectSpread(_objectSpread({}, e), {}, {
          deltaY: -100
        }));
      }

      return;
    }

    var projectedMouse = projectMouse(e);

    if (toolMode === "pan" || e.button === 1 || e.button === 2) {
      setMiddleMouseDown(false);
    } else if (e.button === 0) {
      if (Math.abs(dragStartTime - projectedMouse.x) === 0) {
        onCreateTimestamp(projectedMouse.x);
      }

      setPrimaryDrag(false);
      onDragDurationEnd();
    }
  });
  var onContextMenu = (0, _useEventCallback.default)(function (e) {
    e.preventDefault();
  });
  var containerMountCallback = (0, _react.useCallback)(function (ref) {
    if (ref === null) {
      containerRef.current.removeEventListener("wheel", onWheel);
      containerRef.current = ref;
    } else {
      containerRef.current = ref;
      ref.addEventListener("wheel", onWheel, {
        passive: false
      });
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(Container, {
    ref: containerMountCallback,
    onMouseMove: onMouseMove,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onContextMenu: onContextMenu
  }, children);
};

exports.MouseTransformHandler = MouseTransformHandler;
var _default = MouseTransformHandler;
exports.default = _default;